function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogoDark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 139.99 42.04",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M61.68,17.57V7.89h2.76a4.55,4.55,0,0,1,4.81,4.25,4,4,0,0,1,0,.6,4.6,4.6,0,0,1-4.35,4.83H61.68Zm-2.45,2.17h5.21c4.36,0,7.32-2.88,7.32-7s-3-7-7.32-7H59.23Z",
    transform: "translate(-0.5 -0.5)",
    style: {
      fill: "#211f22"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.59,11.15a2.72,2.72,0,0,1,2.85,2.57v.12H75.73a2.8,2.8,0,0,1,2.86-2.69m-5.15,3.51A5.11,5.11,0,0,0,78.3,20a3.53,3.53,0,0,0,.46,0,5.9,5.9,0,0,0,4.11-1.47l-1-1.45A4.23,4.23,0,0,1,79,18.18a3.07,3.07,0,0,1-3.24-2.79h7.84v-.52c0-3.2-2-5.53-5-5.53a5.13,5.13,0,0,0-5.15,5.11v.21",
    transform: "translate(-0.5 -0.5)",
    style: {
      fill: "#211f22"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.88,18.41A6.16,6.16,0,0,0,89.23,20c2.73,0,4.22-1.37,4.22-3.15,0-2.4-2.17-2.9-3.93-3.28-1.2-.27-2.2-.54-2.2-1.32s.74-1.13,1.89-1.13a4.06,4.06,0,0,1,3,1.21l.92-1.55a5.8,5.8,0,0,0-3.94-1.43c-2.57,0-4,1.43-4,3.09,0,2.27,2.08,2.73,3.82,3.11,1.24.27,2.31.58,2.31,1.47s-.67,1.24-2,1.24a5.25,5.25,0,0,1-3.44-1.43Z",
    transform: "translate(-0.5 -0.5)",
    style: {
      fill: "#211f22"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.67,19.74h2.2V9.6h-2.2ZM96.76,7.92a1.37,1.37,0,1,0-1.37-1.37h0a1.38,1.38,0,0,0,1.36,1.37h0",
    transform: "translate(-0.5 -0.5)",
    style: {
      fill: "#211f22"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.85,16.44a3.31,3.31,0,0,1-2.6,1.37c-1.74,0-2.85-1.3-2.85-3.26s1.11-3.26,2.85-3.26a3.31,3.31,0,0,1,2.6,1.37Zm-7.24,5.9a5.7,5.7,0,0,0,4.24,1.51c2.5,0,5.21-1,5.21-4.64V9.6h-2.2V11a4.07,4.07,0,0,0-3.26-1.66c-2.6,0-4.49,1.94-4.49,5.21s1.91,5.21,4.49,5.21a4.13,4.13,0,0,0,3.26-1.68V19.3c0,2.08-1.56,2.75-3,2.75a3.92,3.92,0,0,1-3.22-1.3Z",
    transform: "translate(-0.5 -0.5)",
    style: {
      fill: "#211f22"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.76,19.74H122V12.6a2.92,2.92,0,0,0-2.55-3.26,3,3,0,0,0-.73,0A4.79,4.79,0,0,0,115.11,11V9.59h-2.2V19.74h2.2V12.66a3.35,3.35,0,0,1,2.6-1.36c1.24,0,2,.52,2,2.1Z",
    transform: "translate(-0.5 -0.5)",
    style: {
      fill: "#211f22"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.32,38.11h2.46v-14H70.32l-3.83,9.42-3.8-9.43H59.23v14h2.46V27.51L66,38.11h1l4.3-10.6Z",
    transform: "translate(-0.5 -0.5)",
    style: {
      fill: "#211f22"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.9,35.8a3,3,0,0,1-2.42,1.05,1.84,1.84,0,1,1-.63-3.63,1.67,1.67,0,0,1,.63,0,3,3,0,0,1,2.42,1.05Zm0,2.31h2.2V31.39c0-2.73-2-3.67-4.22-3.67a6,6,0,0,0-4.27,1.63l.9,1.54a4.16,4.16,0,0,1,3-1.28c1.41,0,2.37.71,2.37,1.89V33a4.18,4.18,0,0,0-3.27-1.3,3.26,3.26,0,0,0-3.52,3c0,.1,0,.21,0,.31a3.36,3.36,0,0,0,3.38,3.36h.15A4.29,4.29,0,0,0,82.88,37Z",
    transform: "translate(-0.5 -0.5)",
    style: {
      fill: "#211f22"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.8,38.11H97V31a2.92,2.92,0,0,0-2.54-3.26,2.55,2.55,0,0,0-.73,0,4.78,4.78,0,0,0-3.57,1.63V28H88V38.11h2.2V31a3.33,3.33,0,0,1,2.6-1.37c1.23,0,2,.52,2,2.1Z",
    transform: "translate(-0.5 -0.5)",
    style: {
      fill: "#211f22"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.07,35.8a3,3,0,0,1-2.42,1.05,1.84,1.84,0,1,1-.63-3.63,1.67,1.67,0,0,1,.63,0,3,3,0,0,1,2.42,1.05Zm0,2.31h2.2V31.39c0-2.73-2-3.67-4.22-3.67a6,6,0,0,0-4.27,1.63l.9,1.54a4.16,4.16,0,0,1,3-1.28c1.41,0,2.38.71,2.38,1.89V33a4.21,4.21,0,0,0-3.28-1.3,3.27,3.27,0,0,0-3.52,3c0,.1,0,.21,0,.31a3.37,3.37,0,0,0,3.38,3.36h.15A4.33,4.33,0,0,0,106.06,37Z",
    transform: "translate(-0.5 -0.5)",
    style: {
      fill: "#211f22"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.25,34.81a3.3,3.3,0,0,1-2.6,1.37c-1.74,0-2.86-1.3-2.86-3.26s1.11-3.25,2.86-3.25a3.32,3.32,0,0,1,2.6,1.36ZM111,40.71a5.73,5.73,0,0,0,4.24,1.52c2.5,0,5.21-1,5.21-4.65V28h-2.2v1.41A4,4,0,0,0,115,27.72c-2.6,0-4.5,1.93-4.5,5.21s1.91,5.2,4.5,5.2a4.1,4.1,0,0,0,3.25-1.68v1.22c0,2.08-1.55,2.75-3,2.75a3.91,3.91,0,0,1-3.21-1.3Z",
    transform: "translate(-0.5 -0.5)",
    style: {
      fill: "#211f22"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.82,29.52a2.72,2.72,0,0,1,2.86,2.57v.12H125a2.8,2.8,0,0,1,2.85-2.69M122.68,33a5.1,5.1,0,0,0,4.85,5.33H128a5.89,5.89,0,0,0,4.12-1.47l-1-1.45a4.27,4.27,0,0,1-2.88,1.12A3.07,3.07,0,0,1,125,33.77h7.83v-.53c0-3.19-1.95-5.52-5-5.52a5.13,5.13,0,0,0-5.15,5.1,1.48,1.48,0,0,0,0,.21",
    transform: "translate(-0.5 -0.5)",
    style: {
      fill: "#211f22"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135,38.11h2.2V31.2a3.53,3.53,0,0,1,2.6-1.34,4,4,0,0,1,.69.06V27.74a4.35,4.35,0,0,0-3.3,1.72V28H135Z",
    transform: "translate(-0.5 -0.5)",
    style: {
      fill: "#211f22"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.49,42.54h-32A6.94,6.94,0,0,1,.5,35.6h0V7.45A6.94,6.94,0,0,1,7.43.5H39.49a6.94,6.94,0,0,1,6.94,6.93V35.59a6.94,6.94,0,0,1-6.93,6.95Zm-5.32-19.4h0V35.59h5.32V8.22a.8.8,0,0,0-.81-.78h-.75a.82.82,0,0,0-.78.38l-8.54,13.4L24,12.87a8.49,8.49,0,0,0-1-1.37,11.77,11.77,0,0,0-1.36-1.28,11.92,11.92,0,0,0-2-1.28C17.37,7.82,12.89,7.7,11.07,7.7H9.24a1.82,1.82,0,0,0-1.8,1.83V32A3.57,3.57,0,0,0,8.5,34.55a3.61,3.61,0,0,0,1.14.76,3.52,3.52,0,0,0,1.39.28h5.19A12.79,12.79,0,0,0,19.46,35a11.45,11.45,0,0,0,2.68-1.3,12.49,12.49,0,0,0,2.2-1.84,17.75,17.75,0,0,0,1.8-2.25l-3.29-5.32A7,7,0,0,1,21.19,28a7.46,7.46,0,0,1-3.57,2.09,15.13,15.13,0,0,1-4.13.51h-.31V12.8h0a9.24,9.24,0,0,1,3.87.85,6.43,6.43,0,0,1,1.9,1.7l9.29,15.09h.54l5.39-7.29ZM13.71,33.27a5.49,5.49,0,0,1-.42-1.36A6,6,0,0,0,13.71,33.27Z",
    transform: "translate(-0.5 -0.5)",
    style: {
      fill: "#211f22"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoDark);
export default __webpack_public_path__ + "static/media/logo-dark.7c41fb32739571e75febccc2f0dec0c8.svg";
export { ForwardRef as ReactComponent };